// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3XWay","label":"Completed_label__2RttH"};